import { Nullable } from "@core/domain/types/nullable.type";
import { TerminationCategoryEnumDto } from "@entity/data/dto/employee/termination-category.dto";
import { TerminationCategoryEnum } from "@entity/domain/models/employee/termination-category.model";
import { injectable } from "inversify";

@injectable()
export class TerminationCategoryEnumMapper {
    map(
        terminationCategoryEnumDto: TerminationCategoryEnumDto,
    ): Nullable<TerminationCategoryEnum> {
        switch (terminationCategoryEnumDto) {
            case TerminationCategoryEnumDto.medical_leave:
                return TerminationCategoryEnum.medical_leave;
            case TerminationCategoryEnumDto.contract_termination:
                return TerminationCategoryEnum.contract_termination;
            default:
                return null;
        }
    }

    reverse(
        terminationCategoryEnum: TerminationCategoryEnum,
    ): Nullable<TerminationCategoryEnumDto> {
        switch (terminationCategoryEnum) {
            case TerminationCategoryEnum.medical_leave:
                return TerminationCategoryEnumDto.medical_leave;
            case TerminationCategoryEnum.contract_termination:
                return TerminationCategoryEnumDto.contract_termination;
            default:
                return null;
        }
    }
}
